@let noFile = !file();

<input #fileInput type="file" [accept]="acceptTypes()" hidden (input)="onFileSelected($event)" />

@if (noFile) {
  @if (isMulti()) {
    <rp-icon class="remove-btn" [iconName]="icons.Remove" size="l" (iconClick)="onNoFileRemove($event)" />
  }
  <rp-icon [iconName]="icons.FileUpload" size="l" />
  <div class="primary-text">
    {{ 'general.placeholders.fileUpload' | translate }}
  </div>
  <div class="secondary-text">
    @if (acceptTypesHint()) {
      <span [innerHTML]="acceptTypesHint() | translate"></span>
    }
    {{ 'general.placeholders.fileUploaderParams' | translate: { size: maxSizeView(), unit: maxSizeUnit() } }}
  </div>
} @else {
  <rp-icon class="remove-btn" [iconName]="icons.Remove" size="l" (iconClick)="onRemove($event)" />
  @if (showEyeIcon()) {
    <rp-icon class="eye-icon" [iconName]="icons.Eye" size="l" (iconClick)="eyeIconClicked.emit()" />
  } @else {
    <rp-icon [iconName]="iconNameByExtension[file().fileExtension]" size="l" />
    <div class="primary-text file-name">
      {{ file().fileName }}
    </div>
  }
}
